import React, { useState } from 'react';
import { Accordion, Typography } from '@guildeducationinc/recess';
import { useHits, useRefinementList } from 'react-instantsearch-hooks-web';
import { useMemberExperienceAuth } from '@guildeducationinc/auth-frontend-tools';
import { useSearchContext } from '@src/components/Providers/SearchProvider';
import { RefinementListFacetValueSet } from '@src/components/RefinementListFacetValueSet';
import { trackFilterEvents } from '../filterHelpers';

export const ProgramFormatFilter: React.FC = () => {
	const [toggleAccordion, setToggleAccordion] = useState<boolean>(false);
	const [selectedChildrenFilterCount, setSelectedChildrenFilterCount] = useState<number>(0);

	const { results } = useHits();
	const { userFromIdToken: user } = useMemberExperienceAuth();
	const { index } = useSearchContext();

	const { items, refine } = useRefinementList({
		attribute: 'programFormatDisplay',
		sortBy: ['name'],
	});

	const FilterTitle: React.FC = () => {
		const selectedFacetsCount = items.filter(facet => facet.isRefined).length;
		return (
			<Typography testid='program-format-title' variant='h6'>{`Class format ${
				selectedFacetsCount > 0 ? `(${selectedFacetsCount + selectedChildrenFilterCount})` : ''
			}`}</Typography>
		);
	};

	if (items.length === 0) {
		return null;
	}

	return (
		<Accordion
			defaultOpen={toggleAccordion}
			testid='programFormatFilterAccordion'
			title={FilterTitle}
		>
			{items.map(facet => (
				<div key={facet.label}>
					<RefinementListFacetValueSet
						categoryLabel={facet.label}
						facet={facet}
						onChange={facetValue => {
							refine(facetValue);
							setToggleAccordion(true);

							const eventName = facet.isRefined ? 'FilterRemoved' : 'FilterAdded';
							trackFilterEvents(
								'programFormat',
								eventName,
								'programFormat',
								facetValue,
								index,
								results,
								user
							);
						}}
						setSelectedChildrenFilterCount={setSelectedChildrenFilterCount}
					/>
				</div>
			))}
		</Accordion>
	);
};
